<template>
  <div>
    <div>
      <app-header/>
    </div>
    <div>
      <transition name="slide" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
    <b-modal v-model="isComponentDiaporama"
             has-modal-card
             class="modal">
      <app-diaporama :faces="getFacesSelect"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as typesModal from '@/store/creationOpportunite/modal-mutation-type';
import Header from './Header';
import Diaporama from './general/diaporama';

const Modal = createNamespacedHelpers('modal');
export default {
  name: 'App',
  components: {
    appHeader: Header,
    appDiaporama: Diaporama,
  },
  data() {
    return {
    };
  },
  computed: {
    ...Modal.mapGetters({
      getIsComponentDiaporama: 'isComponentDiaporama',
      getFacesSelect: 'facesSelectDiapo',
    }),
    isComponentDiaporama: {
      get() {
        return this.getIsComponentDiaporama;
      },
      set(value) {
        this.setIsComponentDiaporama(value);
      },
    },
  },
  methods: {
    ...Modal.mapMutations({
      setIsComponentDiaporama: typesModal.SET_IS_COMPONENT_DIAPORAMA,
    }),
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/App.vue